import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const TeachersCalendarLazy = React.lazy(
	() => import(/* webpackChunkName : 'CalendarsLazy' */ './components')
);

export default (store) => {
	return {
		path: 'teacher-view/:campusId?/:staffId',
		element: <AsyncLoading component={<TeachersCalendarLazy />} />,
		children: [],
	};
};
